export default [
  {
    id: 1,
    name_ca: 'Persona física',
    name_en: 'Natural person',
    name_es: 'Persona física'
  },
  {
    id: 2,
    name_ca: 'Persona jurídica',
    name_en: 'Legal person',
    name_es: 'Persona jurídica'
  }
]



// WEBPACK FOOTER //
// ./src/options/person_types.js